export default __webpack_public_path__ + "static/media/Leads.73b629fb.svg";